import {
  FacebookShareButton,
  EmailShareButton,
  TwitterShareButton,
} from "react-share";
import { FaFacebookF, FaTwitter } from "react-icons/fa";
import { ucword } from "../lib/helper";
import { DOMAIN_URL } from "../services/api";
import classNames from "classnames";
const VideoStream = ({
  videoId,
  isFavoriteStream,
  onAddFavoriteStream,
  onRemoveFavoriteStream,
  currentUser,
  loading,
  church,
  isFavoriteChurch,
  onAddFavorite,
  onRemoveFavorite,
}) => {
  const LINK_TO_SHARE = `${DOMAIN_URL}/church/${church.id}`;

  const renderFavoriteButton =
    !isFavoriteChurch || !currentUser ? (
      <button
        type="button"
        className="inline-block px-8 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded-full shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
        onClick={onAddFavorite}
        disabled={loading}
      >
        Add to Favorites
      </button>
    ) : (
      <button
        type="button"
        className="inline-block px-8 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded-full shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
        onClick={onRemoveFavorite}
        disabled={loading}
      >
        Remove from Favorites
      </button>
    );

  const favoriteStreamButton2 = !isFavoriteStream ? (
    <button
      type="button"
      className="flex justify-center items-center px-8 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded-full shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
      onClick={onAddFavoriteStream}
      disabled={loading}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-4 w-4 mr-1"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
          clipRule="evenodd"
        />
      </svg>
      SAVE SERMON
    </button>
  ) : (
    <button
      type="button"
      className="flex justify-center items-center px-8 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded-full shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
      onClick={onRemoveFavoriteStream}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-4 w-4 fill-red-500 mr-1"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
          clipRule="evenodd"
        />
      </svg>
      SAVED SERMON
    </button>
  );
  return (
    <div>
      <div className="relative aspect-video">
        <iframe
          width="100%"
          height="100%"
          src={`https://www.youtube.com/embed/${videoId}?&autoplay=1`}
          title={videoId}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <div
        className={classNames(
          currentUser ? "justify-between" : "md:justify-between",
          "my-2 flex px-2 md:px-0"
        )}
      >
        <div className="py-1 flex">
          <div className="church-favorite-button">{renderFavoriteButton} </div>
          {currentUser && favoriteStreamButton2}
        </div>

        <div className="flex flex-row items-center gap-x-2">
          <EmailShareButton
            url={LINK_TO_SHARE}
            subject={"StreamChurch - " + ucword(church.name)}
            //body={LINK_TO_SHARE}
          >
            <div className="inline-block bg-transparent text-gray-900 font-bold text-xl leading-tight uppercase">
              Share
            </div>
          </EmailShareButton>
          {/* {!_.isEmpty(socials) && <SocialMedia socials={socials} />} */}
          <div className="flex flex-row gap-x-3">
            <FacebookShareButton
              url={LINK_TO_SHARE}
              quote={ucword(church.name)}
              hashtag="streamchurch"
            >
              <FaFacebookF size={24} />
            </FacebookShareButton>

            <TwitterShareButton
              url={LINK_TO_SHARE}
              title={ucword(church.name)}
              hashtags={["streamchurch"]}
            >
              <FaTwitter size={24} />
            </TwitterShareButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoStream;
